var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "template-page" },
    [
      _vm._m(0),
      _c(
        "el-form",
        {
          ref: "queryFormRef",
          attrs: {
            model: _vm.tableFrom,
            size: "small",
            inline: "",
            "label-width": "66px",
          },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "商品信息：", prop: "productInfo" } },
            [
              _c("el-input", {
                staticClass: "selWidth",
                attrs: {
                  placeholder: "请输入商品编码、ID 或 名称",
                  size: "small",
                  clearable: "",
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleSearchList($event)
                  },
                },
                model: {
                  value: _vm.tableFrom.productInfo,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.tableFrom,
                      "productInfo",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "tableFrom.productInfo",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handleSearchList },
                },
                [_vm._v("搜索")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mt5" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "hasPermi",
                  rawName: "v-hasPermi",
                  value: ["platform:price:monitor:rule:save"],
                  expression: "['platform:price:monitor:rule:save']",
                },
              ],
              attrs: { size: "small", type: "primary", plain: "" },
              on: {
                click: function ($event) {
                  return _vm.openForm("create")
                },
              },
            },
            [
              _c("i", {
                staticClass: "el-icon-circle-plus-outline",
                staticStyle: { "vertical-align": "middle" },
              }),
              _vm._v(" 添加 "),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mt20" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              ref: "tableRef",
              attrs: { data: _vm.tableData.data, size: "small", stripe: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  type: "index",
                  width: "50",
                  index: function (index) {
                    return (
                      (_vm.tableFrom.page - 1) * _vm.tableFrom.limit + index + 1
                    )
                  },
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "productId",
                  label: "商品ID",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "商品",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "flex items-center" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "demo-image__preview line-heightOne mr10",
                            },
                            [
                              _c("el-image", {
                                attrs: {
                                  src: scope.row.productImage,
                                  "preview-src-list": [scope.row.productImage],
                                },
                              }),
                            ],
                            1
                          ),
                          _c("span", { staticClass: "text-overflow" }, [
                            _vm._v(_vm._s(scope.row.productName)),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "规格",
                  "min-width": "100",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "text-overflow" }, [
                          _vm._v(_vm._s(scope.row.specName)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "上涨预警阈值(比例)", "min-width": "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.raiseWarnRatio
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  Number(scope.row.raiseWarnRatio).toFixed(2)
                                ) + "%"
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "下降预警阈值(比例)", "min-width": "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.decreaseWarnRatio
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  Number(scope.row.decreaseWarnRatio).toFixed(2)
                                ) + "%"
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "raiseWarnFix",
                  label: "上涨预警阈值(固定值)",
                  "min-width": "140",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "decreaseWarnFix",
                  label: "下降预警阈值(固定值)",
                  "min-width": "140",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "comparePlatformName",
                  label: "对比平台",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "specialRuleDesc",
                  label: "特殊监控规则",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "monitorFrequencyName",
                  label: "监控频率",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "100", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.checkAllPermi([
                          "platform:price:monitor:rule:save",
                          "platform:price:monitor:rule:detail",
                        ])
                          ? _c(
                              "a",
                              {
                                staticClass: "mr10",
                                on: {
                                  click: function ($event) {
                                    return _vm.openForm("update", scope.row.id)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            )
                          : _vm._e(),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["platform:price:monitor:rule:delete"],
                                expression:
                                  "['platform:price:monitor:rule:delete']",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.handlerOpenDel(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c(
                "template",
                { slot: "empty" },
                [_c("el-empty", { attrs: { description: "暂无数据~" } })],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "block" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "page-sizes": [10, 20, 40, 60, 80],
              "page-size": _vm.tableFrom.limit,
              "current-page": _vm.tableFrom.page,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.tableData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.pageChange,
            },
          }),
        ],
        1
      ),
      _c("SpecificProductRulesForm", {
        ref: "formRef",
        on: { success: _vm.getList },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tips-box flex items-center mb20" }, [
      _c("span", { staticClass: "tips-label" }, [_vm._v("特定商品监控规则")]),
      _c("i", { staticClass: "el-icon-warning-outline" }),
      _c("span", [
        _vm._v(
          "为特定商品设置的监控规则将优先于全局规则生效，适用于需要特殊监控的高价值或敏感商品"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }